import { useContext, Dispatch } from 'react';
import { createNamedContext } from '@utils';

type ReportKeyContextValue =
  [string, Dispatch<string>];

export const ReportKeyContext = createNamedContext<ReportKeyContextValue>(null, 'ReportKeyContext');

export const useReportKey = () => useContext(ReportKeyContext);